import { Component, OnInit } from '@angular/core';
import { CompanyParamsService } from '../../services/company-params.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-whastapp-button',
    templateUrl: './whastapp-button.component.html',
    styleUrls: ['./whastapp-button.component.scss'],
    imports: [NgIf]
})
export class WhastappButtonComponent implements OnInit {

  whatsappNumber = '';

  constructor(
    public companyParamsService: CompanyParamsService,
  ) { }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.companyParamsService.company)) {
      return;
    }
    this.whatsappNumber = this.companyParamsService.company.whatsappNumber != '' ?
      (this.isNullOrUndefined(this.companyParamsService.company.whatsappNumber) ? '' : this.companyParamsService.company.whatsappNumber) : '';
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

}
